module.exports = __webpack_public_path__ + "img/logo-and-text.e8723010.svg";